import { faEyeSlash } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Switch, Typography } from "@joonapp/web-shared"
import { useState } from "react"

import useQuestBoardDndFilters from "./hooks/useQuestBoardDndFilters"
import InactiveQuestCard from "./InactiveQuestCard"

const InactiveQuestsSection = () => {
  const { inactiveQuests } = useQuestBoardDndFilters()
  const [showInactiveQuests, setShowInactiveQuests] = useState(false)

  if (inactiveQuests.length === 0) return null

  return (
    <div className="flex flex-col mb-4 gap-2 border border-borderPrimary rounded-md bg-bgXLightGray p-2">
      <div className="flex flex-row gap-2 items-center">
        <FontAwesomeIcon icon={faEyeSlash} color={JoonUIColor.icon.neutral} />
        <Typography variant="bodySmallBold">
          Show Inactive Quests ({inactiveQuests.length})
        </Typography>
        <Switch
          name="toggle-inactive-quests"
          checked={showInactiveQuests}
          onChange={() => setShowInactiveQuests(!showInactiveQuests)}
          style={{ marginLeft: "auto" }}
          variant="small"
        />
      </div>
      {showInactiveQuests && (
        <div className="flex flex-col gap-2">
          {inactiveQuests.map((quest) => (
            <InactiveQuestCard key={quest.id} questSeries={quest} />
          ))}
        </div>
      )}
    </div>
  )
}

export default InactiveQuestsSection
